import type { FaireProductEntity } from "../../entity_types/product";

export const p_hpekb5fb29: FaireProductEntity = {
  token: "p_hpekb5fb29",
  type: "product",
  name: "PUT IT ON MY DAD'S TAB Embroidery KIDS Trucker Hat",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/d009caf89fff1e8e238062421e95e9d653828f7d8d47fbbfae68217d481fda9f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1f35e05a73879b81a3b48a3ad73583228c84813bf13b34062b96b1d47e9b4a77.jpeg",
    "https://cdn.faire.com/fastly/885c1a9fa43bd23dcb65769d91412e839ebfd15bf945347293bf28c599e378c6.jpeg",
    "https://cdn.faire.com/fastly/b1e90f72c15464b56e1b49467dc9e472171aa8c6114239e8f9d20783c0e520cb.jpeg",
    "https://cdn.faire.com/fastly/35fd6176c12e96d602a78d12218e9bb2eb45c64b04346ad7205a04a8ea8a8a3b.jpeg",
    "https://cdn.faire.com/fastly/213995422e863a4de64f2059cb12ae8c81b87a4e2ee30811b92c7509499c75ff.jpeg",
    "https://cdn.faire.com/fastly/f4dc22717fc64e65ffe7f0246491103338fdba9507d9595a1c706575734d1490.jpeg",
    "https://cdn.faire.com/fastly/071da077abe2122756de3c4c8d0edb254e11bda2703b8e79524412f94eca24fe.jpeg",
    "https://cdn.faire.com/fastly/8833a718048930fbc766844fa8f341aa5fa387e527c483b6f903c5d9f2ac4b3a.jpeg",
    "https://cdn.faire.com/fastly/3d7f2170e2c5dbf333663bf8fd91f3b3732ad38b134a620d55bb9399d114bed2.jpeg",
    "https://cdn.faire.com/fastly/f161ef6d7e044f77df472b82da780f2e9e2471ca0cf3fd8a79d7e83dc187e298.jpeg",
    "https://cdn.faire.com/fastly/79e3d6d487ce184b0c46472e520d1f273d0d900fe6564c7a40640d28352ff4dd.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "PUT IT ON MY DAD'S TAB Embroidery KIDS Trucker Hat\nKIDS Circumference: 21 1/4\" (54cm) \n\n- PUT IT ON MY DAD'S TAB Lettering Embroidery \n- 5-Panel Two-Tone Kids Size Trucker Hat\n- 100% Cotton Canvas Hat\n- Embroidered In the USA\n- Base Cap by CC\n\n** One size fits most: Adjustable snapback closure **\n\nLet your little one show off some playful confidence with the “PUT IT ON MY DAD’S TAB” Embroidered Kids Trucker Hat. Designed with a fun, cheeky phrase embroidered across the front, this 5-panel two-tone cap adds personality to any outfit. Crafted from 100% cotton canvas, it offers durability and all-day comfort for active kids. The adjustable snapback closure ensures a secure and comfortable fit as they grow. Each hat is proudly embroidered in the USA on a high-quality CC base cap, making it both stylish and long-lasting. Perfect for family outings, vacations, or everyday adventures.",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:56.406Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
